<agpr-panel
    header="Quotas"
>
    <agpr-quota-preferences
        [isSocial]="true"
        [quotaType]="monitoringQuotaTypes.SOCIAL_LISTENING"
    ></agpr-quota-preferences>
</agpr-panel>
<agpr-panel
    *ngIf="licenses"
    [header]="'Social.agentWidget.networks'"
>
    <div
        class="agpr-monitoring-preferences-subscriptions-licenses agpr-columns checkbox"
    >
        <div>
            <agpr-checkbox
                [id]="'socialPreferences_' + licensesEnum.FACEBOOK"
                [(ngModel)]="licenses[licensesEnum.FACEBOOK]"
                [disabled]="isReadOnly"
                label="AMT.subscriptions.licenses.facebook"
                [binary]="true"
                (ngModelChange)="onLicenseChange()"
            ></agpr-checkbox>
            <agpr-checkbox
                [id]="'socialPreferences_' + licensesEnum.INSTAGRAM"
                [(ngModel)]="licenses[licensesEnum.INSTAGRAM]"
                [disabled]="isReadOnly"
                label="AMT.subscriptions.licenses.instagram"
                [binary]="true"
                (ngModelChange)="onLicenseChange()"
            ></agpr-checkbox>
            <agpr-checkbox
                [id]="'socialPreferences_' + licensesEnum.REDDIT"
                [(ngModel)]="licenses[licensesEnum.REDDIT]"
                [disabled]="isReadOnly"
                label="AMT.subscriptions.licenses.reddit"
                [binary]="true"
                (ngModelChange)="onLicenseChange()"
            ></agpr-checkbox>
        </div>
        <div>
            <agpr-checkbox
                [id]="'socialPreferences_' + licensesEnum.TWITTER"
                [(ngModel)]="licenses[licensesEnum.TWITTER]"
                [disabled]="isReadOnly"
                label="AMT.subscriptions.licenses.twitter"
                [binary]="true"
                (ngModelChange)="onLicenseChange()"
            ></agpr-checkbox>
            <agpr-checkbox
                [id]="'socialPreferences_' + licensesEnum.YOUTUBE"
                [(ngModel)]="licenses[licensesEnum.YOUTUBE]"
                [disabled]="isReadOnly"
                label="AMT.subscriptions.licenses.youtube"
                [binary]="true"
                (ngModelChange)="onLicenseChange()"
            ></agpr-checkbox>
            <agpr-checkbox
                [id]="'socialPreferences_' + licensesEnum.TIKTOK"
                [(ngModel)]="licenses[licensesEnum.TIKTOK]"
                label="AMT.subscriptions.licenses.tiktok"
                [binary]="true"
                [disabled]="isReadOnly"
                (ngModelChange)="onLicenseChange()"
            >
                <span
                    role="img"
                    class="agpr-social-preferences-info fa-regular fa-circle-info"
                    agprTooltip="AMT.subscriptions.licenses.tiktok.tooltip"
                ></span>
            </agpr-checkbox>
        </div>
        <div>
            <agpr-checkbox
                [id]="'socialPreferences_' + licensesEnum.LINKEDIN"
                [(ngModel)]="licenses[licensesEnum.LINKEDIN]"
                [disabled]="isReadOnly"
                label="AMT.subscriptions.licenses.linkedin"
                [binary]="true"
                (ngModelChange)="onLicenseChange()"
            ></agpr-checkbox>
            <agpr-checkbox
                [id]="'socialPreferences_' + licensesEnum.BLUESKY"
                [(ngModel)]="licenses[licensesEnum.BLUESKY]"
                [disabled]="isReadOnly"
                label="AMT.subscriptions.licenses.bluesky"
                [binary]="true"
                (ngModelChange)="onLicenseChange()"
            ></agpr-checkbox>
        </div>
    </div>
</agpr-panel>
<agpr-form-message
    *ngIf="networks.errors?.['required']"
    id="socialPreferences_noNetwork_error"
>
    {{ "AMT.social.networks.errorMessage" | localize }}
</agpr-form-message>

<agpr-unsaved-export-preferences></agpr-unsaved-export-preferences>